<template>
  <div class="resultsAll">
    <div class="resultsAll_header">
      <div v-if="isNew && code === 'J'" class="newResults">
        <el-button type="success" @click="dialogNewResults = true">新成果</el-button>
      </div>
      <div class="newResults" v-else></div>
      <div class="el-input" v-if="code === '13' || code === '1' || code === 'Y'"></div>

      <el-select
        v-else
        v-model="val"
        multiple
        filterable
        remote
        loading-text="搜索中"
        reserve-keyword
        placeholder="请输入关键词"
        @change="add"
        :remote-method="search"
        :loading="loading"
      >
        <el-option
          v-for="item in searchList"
          :key="item.id"
          :value="item"
        >{{item.title || item.Title}}</el-option>
      </el-select>
      <el-button
        type="primary"
        @click="dialogFormVisible =true"
        v-if="code  !== 'Y' && code !== '13' "
      >+手动输入添加</el-button>
    </div>
    <div class="resultsAll_body">
      <el-table border :data="tabelList" style="width: 100%" ref="dataTable" v-if="code !== 'Y' ">
        <!-- 我的履历 -->
        <el-table-column prop="BeginDate" label="起始时间" show-overflow-tooltip v-if="code === '1'">
          <template
            slot-scope="scope"
          >{{scope.row.BeginDate?scope.row.BeginDate.slice(0,10):scope.row.BeginDate}}</template>
        </el-table-column>
        <el-table-column label="截至时间" show-overflow-tooltip v-if="code === '1'">
          <template
            slot-scope="scope"
          >{{scope.row.EndDate?scope.row.EndDate.slice(0,10):scope.row.EndDate}}</template>
        </el-table-column>
        <el-table-column label="所在机构" show-overflow-tooltip v-if="code === '1'">
          <template slot-scope="scope">{{scope.row.Organization.Name}}</template>
        </el-table-column>
        <el-table-column label="二级机构" show-overflow-tooltip v-if="code === '1'">
          <template slot-scope="scope">{{scope.row.Department}}</template>
        </el-table-column>
        <el-table-column label="职位" show-overflow-tooltip v-if="code === '1'">
          <template slot-scope="scope">{{scope.row.Position}}</template>
        </el-table-column>
        <el-table-column label="职称" show-overflow-tooltip v-if="code === '1'">
          <template slot-scope="scope">{{scope.row.PositionalTitle}}</template>
        </el-table-column>

        <!-- 我的论文 -->
        <div v-if="code === 'J' ">
          <el-table-column label="篇名" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.Url"
                :underline="false"
                type="primary"
                :href="unescape(scope.row.Url)"
                target="_blank"
              >{{scope.row.Title}}</el-link>
              <span v-else>{{scope.row.Title}}</span>
            </template>
          </el-table-column>
          <el-table-column label="作者" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Creator}}</template>
          </el-table-column>
          <el-table-column label="刊名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Journal}}</template>
          </el-table-column>
          <el-table-column label="年/期" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Year}}/{{scope.row.Issue?scope.row.Issue:'-'}}</template>
          </el-table-column>
        </div>

        <!-- SCI -->
        <div v-if="code === 'I' ">
          <el-table-column label="篇名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="作者" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Creator}}</template>
          </el-table-column>
          <el-table-column label="刊名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Journal}}</template>
          </el-table-column>
          <el-table-column label="年 / 期" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Year}}/{{scope.row.Issue?scope.row.Issue:'-'}}</template>
          </el-table-column>
        </div>

        <!-- EI -->
        <div v-if="code === 'E' ">
          <el-table-column label="篇名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="作者" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Creator}}</template>
          </el-table-column>
          <el-table-column label="机构" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Institute}}</template>
          </el-table-column>
          <el-table-column label="刊名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Journal}}</template>
          </el-table-column>
          <el-table-column label="年/期" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Year}}/{{scope.row.Issue?scope.row.Issue:'-'}}</template>
          </el-table-column>
        </div>

        <!-- 我的专利 -->
        <div v-if="code === 'P'">
          <el-table-column label="专利名称" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="发明人" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Creator}}</template>
          </el-table-column>
          <el-table-column label="专利号" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.PatentNo}}</template>
          </el-table-column>
          <el-table-column label="申请号" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.ApplicationNo}}</template>
          </el-table-column>
          <el-table-column label="申请机构" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Institute}}</template>
          </el-table-column>
        </div>

        <!-- 我的项目 -->
        <div v-if="code === 'O'">
          <el-table-column label="项目名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
        </div>

        <!-- 我的图书 -->
        <div v-if="code === 'B'">
          <el-table-column label="书名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="作者" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Creator}}</template>
          </el-table-column>
          <el-table-column label="ISBN号" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.ISBN}}</template>
          </el-table-column>
        </div>

        <!-- 成果奖励 -->
        <div v-if="code === 'A'">
          <el-table-column label="成果名称" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="年份" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Year}}</template>
          </el-table-column>
          <el-table-column label="奖励人" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Creator}}</template>
          </el-table-column>
        </div>

        <!-- 会议论文 -->
        <div v-if="code === 'C'">
          <el-table-column label="篇名" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                :href="scope.row.Url"
                target="_blank"
              >{{scope.row.Title}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="作者" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Creator}}</template>
          </el-table-column>
          <el-table-column label="刊名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Journal}}</template>
          </el-table-column>
          <el-table-column label="年/期" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Year}}/{{scope.row.Issue?scope.row.Issue:'-'}}</template>
          </el-table-column>
        </div>

        <!-- 学位论文 -->
        <div v-if="code === 'D'">
          <el-table-column label="论文名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="作者" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Creator}}</template>
          </el-table-column>
          <el-table-column label="导师" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Tutor}}</template>
          </el-table-column>
          <!-- <el-table-column label="机构" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Institute}}</template>
          </el-table-column>-->
          <el-table-column label="年份" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Year}}</template>
          </el-table-column>
          <el-table-column label="期刊" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Journal}}</template>
          </el-table-column>
        </div>

        <!-- 我的团队 -->
        <div v-if="code === 'T'">
          <el-table-column label="姓名" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.TeamMemberName}}</template>
          </el-table-column>
          <el-table-column label="机构" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Institute}}</template>
          </el-table-column>
          <el-table-column label="合作紧密度(1-10)" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.TeamMemberWeight}}</template>
          </el-table-column>
        </div>
        <el-table-column prop="position" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="danger" @click="edit(scope.$index)" size="mini" v-if="code === '1'">更改</el-button>
            <el-upload
              style="float:left"
              ref="upload"
              action="action"
              :http-request="uploadFile"
              :file-list="fileList"
              :on-remove="handleRemove"
              :auto-upload="false"
              v-else
            >
              <el-button type="warning" @click="upload" size="mini">上传原文</el-button>
            </el-upload>
            <el-button
              type="danger"
              @click="del(scope.$index)"
              size="mini"
              style="margin-left:20px"
            >删除</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="address" label="地址" type></el-table-column>
        <el-table-column prop="name" label="书名" type v-else-if="code === 'B'"></el-table-column>-->
      </el-table>
      <!-- 我的活动 -->
      <div v-if="code === 'Y'">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1">我的会议</el-menu-item>
          <el-menu-item index="2">我的授课</el-menu-item>
        </el-menu>
        <el-table border :data="tabelList" style="width: 100%" ref="dataTable">
          <div v-if="activeIndex === '1'">
            <el-table-column label="会议名称" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.Title}}</template>
            </el-table-column>
            <el-table-column label="会议地点" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.Title}}</template>
            </el-table-column>
            <el-table-column label="会议时间" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.Title}}</template>
            </el-table-column>
            <el-table-column label="备注" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.Title}}</template>
            </el-table-column>
            <el-table-column prop="position" label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  @click="edit(scope.$index)"
                  size="mini"
                  v-if="code === '1'"
                >更改</el-button>
                <el-upload
                  style="float:left"
                  ref="upload"
                  action="action"
                  :http-request="uploadFile"
                  :file-list="fileList"
                  :on-remove="handleRemove"
                  :auto-upload="false"
                  v-else
                >
                  <el-button type="warning" @click="upload" size="mini">上传原文</el-button>
                </el-upload>

                <el-button
                  type="danger"
                  @click="del(scope.$index)"
                  size="mini"
                  style="margin-left:20px"
                >删除</el-button>
              </template>
            </el-table-column>
          </div>
          <div v-if="activeIndex === '2'">
            <el-table-column label="课程名称" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.Title}}</template>
            </el-table-column>
            <el-table-column label="课程地点" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.Title}}</template>
            </el-table-column>
            <el-table-column label="课程时间" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.Title}}</template>
            </el-table-column>
            <el-table-column label="备注" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.Title}}</template>
            </el-table-column>
            <el-table-column prop="position" label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  @click="edit(scope.$index)"
                  size="mini"
                  v-if="code === '1'"
                >更改</el-button>
                <el-upload
                  style="float:left"
                  ref="upload"
                  action="action"
                  :http-request="uploadFile"
                  :file-list="fileList"
                  :on-remove="handleRemove"
                  :auto-upload="false"
                  v-else
                >
                  <el-button type="warning" @click="upload" size="mini">上传原文</el-button>
                </el-upload>
                <el-button
                  type="danger"
                  @click="del(scope.$index)"
                  size="mini"
                  style="margin-left:20px"
                >删除</el-button>
              </template>
            </el-table-column>
          </div>
        </el-table>
      </div>

      <!-- 回收站 -->
      <div v-if="code === '13'">
        <el-table border :data="tabelList" style="width: 100%" ref="dataTable">
          <el-table-column label="资源名称" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="所属类型" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="操作时间" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="自动清除时间" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column prop="position" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                type="danger"
                @click="edit(scope.$index)"
                size="mini"
                v-if="code === '1'"
              >更改</el-button>
              <el-upload
                style="float:left"
                ref="upload"
                action="action"
                :http-request="uploadFile"
                :file-list="fileList"
                :on-remove="handleRemove"
                :auto-upload="false"
                v-else
              >
                <el-button type="warning" @click="upload" size="mini">上传原文</el-button>
              </el-upload>
              <el-button
                type="danger"
                @click="del(scope.$index)"
                size="mini"
                style="margin-left:20px"
              >删除</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="address" label="地址" type></el-table-column>
          <el-table-column prop="name" label="书名" type v-else-if="code === 'B'"></el-table-column>-->
        </el-table>
      </div>

      <pagination
        :total="Pages.RecordSum"
        :page.sync="Pages.PageNumber"
        :limit.sync="Pages.RecordPaginal"
        :pageSizes="pageSizes"
        :layout="layout"
        @pagination="getPage"
      />
    </div>
    <!-- 上传履历 -->
    <el-dialog class="claimDialog" :title="title[code]" :visible.sync="dialogFormVisible" center>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        :label-width="formLabelWidth"
        class="claimForm"
      >
        <el-form-item label="起始时间" prop="startTime" v-if="code === '1'">
          <el-date-picker
            v-model="form.startTime"
            type="month"
            placeholder="选择起始时间"
            :picker-options="startTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止时间" prop="endTime" v-if="code === '1'">
          <el-date-picker
            v-model="form.endTime"
            type="month"
            placeholder="选择截止时间"
            :picker-options="endTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所在机构" prop="institutions" v-if="code === '1'">
          <el-input v-model="form.institutions" autocomplete="off" placeholder="请输入机构名"></el-input>
        </el-form-item>
        <el-form-item label="二级机构" prop="secInstitutions" v-if="code === '1'">
          <el-input v-model="form.secInstitutions" autocomplete="off" placeholder="请输入二级机构名"></el-input>
        </el-form-item>
        <el-form-item label="职称" prop="title" v-if="code === '1'">
          <el-input v-model="form.title" autocomplete="off" placeholder="请输入职称"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="position" v-if="code === '1'">
          <el-input v-model="form.position" autocomplete="off" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item
          label="篇名"
          prop="article"
          v-if="code === 'J' || code === 'I' || code === 'E' || code === 'C'"
        >
          <el-input v-model="form.article" autocomplete="off" placeholder="请输入篇名"></el-input>
        </el-form-item>
        <el-form-item
          label="作者"
          prop="creator"
          v-if="code === 'J' || code === 'I' || code === 'E' || code === 'C'"
        >
          <el-input v-model="form.creator" autocomplete="off" placeholder="请输入作者"></el-input>
        </el-form-item>
        <el-form-item
          label="刊名"
          prop="kTitle"
          v-if="code === 'J' || code === 'I' || code === 'E' || code === 'C'"
        >
          <el-input v-model="form.kTitle" autocomplete="off" placeholder="请输入刊名"></el-input>
        </el-form-item>
        <el-form-item label="机构" prop="Institute" v-if=" code === 'E'">
          <el-input v-model="form.Institute" autocomplete="off" placeholder="请输入机构"></el-input>
        </el-form-item>
        <el-form-item
          label="年份"
          prop="year"
          v-if="code === 'J' || code === 'I' || code === 'E' || code === 'C'"
        >
          <el-input v-model.number="form.year" autocomplete="off" placeholder="请输入年份"></el-input>
        </el-form-item>

        <el-form-item label="专利名称" prop="patentName" v-if="code === 'P'">
          <el-input v-model="form.patentName" autocomplete="off" placeholder="请输入专利名称"></el-input>
        </el-form-item>
        <el-form-item label="发明人" prop="inventor" v-if="code === 'P'">
          <el-input v-model="form.inventor" autocomplete="off" placeholder="请输入发明人"></el-input>
        </el-form-item>
        <el-form-item label="专利号" prop="patentNo" v-if="code === 'P'">
          <el-input v-model="form.patentNo" autocomplete="off" placeholder="请输入专利号"></el-input>
        </el-form-item>
        <el-form-item label="申请号" prop="itemNo" v-if="code === 'P'">
          <el-input v-model="form.itemNo" autocomplete="off" placeholder="请输入申请号"></el-input>
        </el-form-item>
        <el-form-item label="申请机构" prop="organisation" v-if="code === 'P'">
          <el-input v-model="form.organisation" autocomplete="off" placeholder="请输入申请机构"></el-input>
        </el-form-item>

        <el-form-item label="项目名" prop="projectName" v-if="code === 'O'">
          <el-input v-model="form.projectName" autocomplete="off" placeholder="请输入项目名"></el-input>
        </el-form-item>
        <el-form-item label="项目编号" prop="projectNo" v-if="code === 'O'">
          <el-input v-model="form.projectNo" autocomplete="off" placeholder="请输入项目编号"></el-input>
        </el-form-item>
        <el-form-item label="项目承担人" prop="projectOwner" v-if="code === 'O'">
          <el-input v-model="form.projectOwner" autocomplete="off" placeholder="请输入项目承担人"></el-input>
        </el-form-item>
        <el-form-item label="年份" prop="year" v-if="code === 'O'">
          <el-input v-model.number="form.year" autocomplete="off" placeholder="请输入年份"></el-input>
        </el-form-item>

        <el-form-item label="书名" prop="bookName" v-if="code === 'B'">
          <el-input v-model="form.bookName" autocomplete="off" placeholder="请输入书名"></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="bookAuthor" v-if="code === 'B'">
          <el-input v-model="form.bookAuthor" autocomplete="off" placeholder="请输入作者"></el-input>
        </el-form-item>
        <el-form-item label="ISBN号" prop="ISBN" v-if="code === 'B'">
          <el-input v-model="form.ISBN" autocomplete="off" placeholder="请输入ISBN号"></el-input>
        </el-form-item>

        <el-form-item label="成果名称" prop="resultsName" v-if="code === 'A'">
          <el-input v-model="form.resultsName" autocomplete="off" placeholder="请输入成果名称"></el-input>
        </el-form-item>
        <el-form-item label="年份" prop="resultYaer" v-if="code === 'A'">
          <el-input v-model.number="form.resultYaer" autocomplete="off" placeholder="请输入年份"></el-input>
        </el-form-item>
        <el-form-item label="奖励人" prop="reward" v-if="code === 'A'">
          <el-input v-model="form.reward" autocomplete="off" placeholder="请输入奖励人"></el-input>
        </el-form-item>

        <el-form-item label="论文名" prop="paperName" v-if="code === 'D'">
          <el-input v-model="form.paperName" autocomplete="off" placeholder="请输入轮文名"></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="creator" v-if="code === 'D'">
          <el-input v-model="form.creator" autocomplete="off" placeholder="请输入作者"></el-input>
        </el-form-item>
        <el-form-item label="导师" prop="mentor" v-if="code === 'D'">
          <el-input v-model="form.mentor" autocomplete="off" placeholder="请输入导师"></el-input>
        </el-form-item>
        <el-form-item label="机构" prop="Institute" v-if="code === 'D'">
          <el-input v-model="form.Institute" autocomplete="off" placeholder="请输入机构"></el-input>
        </el-form-item>
        <el-form-item label="年份" prop="resultYaer" v-if="code === 'D'">
          <el-input v-model.number="form.resultYaer" autocomplete="off" placeholder="请输入年份"></el-input>
        </el-form-item>
        <el-form-item label="刊名" prop="kTitle" v-if="code === 'D'">
          <el-input v-model="form.kTitle" autocomplete="off" placeholder="请输入刊名"></el-input>
        </el-form-item>

        <el-form-item label="姓名" prop="成员名称" v-if="code === 'T'">
          <el-input v-model="form.memberName" autocomplete="off" placeholder="请输入成员名称"></el-input>
        </el-form-item>
        <el-form-item label="成员机构" prop="memberOrg" v-if="code === 'T'">
          <el-input v-model="form.memberOrg" autocomplete="off" placeholder="请输入成员机构"></el-input>
        </el-form-item>
        <el-form-item label="合作紧密度" prop="tightness" v-if="code === 'T'">
          <el-input v-model="form.tightness" autocomplete="off" placeholder="请输入合作紧密度"></el-input>
        </el-form-item>
        <el-form-item label="URL" prop="URL" v-if="code === 'J' || code === 'B' || code === 'C'">
          <el-input v-model="form.URL" autocomplete="off" placeholder="请输入URL"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer" width="180">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新成果 -->
    <el-dialog title="新成果" :visible.sync="dialogNewResults" width="70%" :before-close="handleClose">
      <el-table :data="newResultsData" border style="width: 100%">
        <el-table-column prop="Title" label="篇名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Creator" label="作者" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Journal" label="刊名" show-overflow-tooltip></el-table-column>
        <el-table-column label="年/期">
          <template slot-scope="scope">{{scope.row.Year}}/{{scope.row.Issue?scope.row.Issue:'-'}}</template>
        </el-table-column>
        <el-table-column prop="position" label="操作">
          <template slot-scope="scope">
            <el-button
              type="danger"
              @click="claim(scope.row)"
              size="mini"
              style="margin-left:20px"
            >认领</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogNewResults = false">取 消</el-button>
        <el-button type="primary" @click="dialogNewResults = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { formatTime } from "@/utils/index";
export default {
  name: "resultsAll",
  props: {
    tabelList: {
      type: Array
    },
    searchList: {
      type: Array
    },
    code: {
      type: String
    },
    userId: {
      type: Number
    },
    Pages: {
      type: Object
    },
    newResultsData: {
      type: Object
    },
    isNew: {
      type: Boolean
    },
    KID: {
      type: String
    }
  },
  components: {
    Pagination
  },

  watch: {
    tabelList: {
      deep: true,
      handler() {}
    },
    isNew: {
      deep: true,
      handler() {
        this.getNew();
      }
    },
    dialogFormVisible: {
      deep: true,
      handler(val) {
        if (val) {
          return;
        }
        this.resetForm();
      }
    },
    searchList: {
      deep: true,
      handler() {
        this.loading = false;
      }
    }
  },
  data() {
    return {
      val: "",
      activeIndex: "1",
      dialogFormVisible: false,
      dialogNewResults: false,
      loading: false,
      editState: false,
      startTime: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      endTime: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      form: {
        Id: "",
        startTime: "",
        endTime: "",
        institutions: "",
        secInstitutions: "",
        title: "",
        position: "",
        article: "",
        creator: "",
        kTitle: "",
        year: "",
        URL: "",
        Institute: "",
        patentName: "",
        patentNo: "",
        inventor: "",
        itemNo: "",
        organisation: "",
        projectName: "",
        projectNo: "",
        projectOwner: "",
        ISBN: "",
        bookName: "",
        bookAuthor: "",
        resultsName: "",
        resultYaer: "",
        reward: "",
        paperName: "",
        mentor: "",
        memberName: "",
        memberOrg: "",
        tightness: ""
      },
      rules: {
        startTime: [{ required: true, message: "请选择时间", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择时间", trigger: "blur" }],
        institutions: [
          { required: true, message: "请输入机构", trigger: "blur" }
        ],
        article: [{ required: true, message: "请输入篇名", trigger: "blur" }],
        creator: [{ required: true, message: "请输入作者", trigger: "blur" }],
        kTitle: [{ required: true, message: "请输入刊名", trigger: "blur" }],
        year: [
          { required: true, message: "请输入年份", trigger: "blur" },
          {
            pattern: /^-?\d+\.?\d*$/,
            message: "年份格式不对",
            trigger: "change"
          }
        ],
        URL: [{ required: true, message: "请输入URL", trigger: "blur" }],
        Institute: [{ required: true, message: "请输入机构", trigger: "blur" }],
        patentName: [
          { required: true, message: "请输入专利名称", trigger: "blur" }
        ],
        inventor: [
          { required: true, message: "请输入发明人", trigger: "blur" }
        ],
        patentNo: [
          { required: true, message: "请输入专利号", trigger: "blur" }
        ],
        itemNo: [{ required: true, message: "请输入申请号", trigger: "blur" }],
        organisation: [
          { required: true, message: "请输入申请机构", trigger: "blur" }
        ],
        projectName: [
          { required: true, message: "请输入项目名", trigger: "blur" }
        ],
        projectNo: [
          { required: true, message: "请输入项目编号", trigger: "blur" }
        ],
        projectOwner: [
          { required: true, message: "请输入项目承担人", trigger: "blur" }
        ],
        ISBN: [{ required: true, message: "请输入ISBN", trigger: "blur" }],
        bookName: [{ required: true, message: "请输入书名", trigger: "blur" }],
        bookAuthor: [
          { required: true, message: "请输入作者", trigger: "blur" }
        ],
        resultsName: [
          { required: true, message: "请输入成果奖励", trigger: "blur" }
        ],
        reward: [{ required: true, message: "请输入奖励人", trigger: "blur" }],
        resultYaer: [
          { required: true, message: "请输入年份", trigger: "blur" },
          {
            pattern: /^-?\d+\.?\d*$/,
            message: "年份格式不对",
            trigger: "change"
          }
        ],
        paperName: [
          { required: true, message: "请输入论文名字", trigger: "blur" }
        ],
        mentor: [{ required: true, message: "请输入导师", trigger: "blur" }],
        memberName: [
          { required: true, message: "请输入成员名称", trigger: "blur" }
        ],
        memberOrg: [
          { required: true, message: "请输入成员机构", trigger: "blur" }
        ],
        tightness: [
          { required: true, message: "请输入合作紧密度", trigger: "blur" },
          {
            pattern: /^-?\d+\.?\d*$/,
            max: 10,
            min: 0,
            message: "紧密度0到10之间",
            trigger: "change"
          }
        ]
      },
      layout: "sizes, prev, pager, next, jumper",
      pageSizes: [8],
      formLabelWidth: "120px",
      title: {
        1: "添加履历",
        J: "添加论文",
        B: "添加图书",
        C: "添加会议论文",
        E: "添加EI论文",
        P: "添加专利",
        O: "添加项目",
        A: "添加成果",
        D: "添加学位论文",
        T: "添加团队",
        I: "添加SCI论文"
      }
    };
  },
  methods: {
    handleSelect(index) {
      this.activeIndex = index;
    },
    // 搜索
    search(index) {
      let temp = [this.code];
      let data = {
        c: temp,
        term: index
      };
      this.loading = true;
      this.$emit("search", data);
    },
    // 添加
    add(list) {
      let temp = list[0];
      temp.ResourceCode = this.code;
      temp.AutoDelete = null;
      temp.CandidateId = temp.candidateResources
        ? temp.candidateResources
            .split(temp.Name)[0]
            .split("<ID>")[1]
            .split("</ID>")[0]
        : "";
      temp.IsConfirmed = true;
      temp.UnionId = temp.resourceId ? temp.resourceId : "";
      temp.KId = this.KID;
      let str = JSON.stringify(temp);
      switch (this.code) {
        case "J":
          temp.Paper = JSON.parse(str);
          break;
        case "I":
          temp.SCI = JSON.parse(str);
          break;
        case "E":
          temp.EI = JSON.parse(str);
          break;
        case "P":
          temp.Patent = JSON.parse(str);
          break;
        case "O":
          temp.Project = JSON.parse(str);
          break;
        case "B":
          temp.Book = JSON.parse(str);
          break;
        case "A":
          temp.Reward = JSON.parse(str);
          break;
        case "C":
          temp.Conference = JSON.parse(str);
          break;
        case "D":
          temp.DegreeObj = JSON.parse(str);
          break;
        default:
          break;
      }
      let data = {
        ExpertResource: temp,
        OperateEmployeeId: 0,
        OperateUserId: this.userId + ""
      };
      this.val = "";
      this.$emit("add", data);
    },
    // 转大写
    toUpperCase(jsonObj) {
      if (typeof jsonObj === "object") {
        for (var key in jsonObj) {
          jsonObj[key.substring(0, 1).toUpperCase() + key.substring(1)] =
            jsonObj[key];
          delete jsonObj[key];
        }
        return jsonObj;
      }
    },
    // 转义
    unescape: function(html) {
      return html
        .replace(/amp;/g, "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    },
    // 提交
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (!this.editState) {
            this.form.startTime = formatTime(this.form.startTime, "{y} - {m}");
            this.form.endTime = formatTime(this.form.endTime, "{y} - {m}");
          }
          let temp = this.form;
          let data;
          if (this.code === "1") {
            data = {
              BeginDate: temp.startTime,
              Department: temp.secInstitutions,
              EndDate: temp.endTime,
              Id: temp.Id,
              KId: this.KID,
              Organization: {
                IsSystem: false,
                IsValid: true,
                Id: "",
                Name: temp.institutions
              },
              Position: temp.position,
              PositionalTitle: temp.title
            };
          } else if (this.cdoe === "13") {
            return;
          } else {
            let ExpertResource = {
              AutoDelete: null,
              CandidateId: "",
              Creator: "2",
              CreatorId: "",
              FilePath: "",
              Id: this.userId + "",
              IsConfirmed: true,
              IsDeleted: true,
              IsSystem: false,
              IsValid: true,
              KId: this.KID,
              OperateTime: "",
              ResourceCode: this.code,
              UnionId: "",
              Url: ""
            };
            switch (this.code) {
              case "J":
                ExpertResource.Title = temp.article;
                ExpertResource.CreatorStandard = temp.creator;
                ExpertResource.Journal = temp.kTitle;
                ExpertResource.Year = temp.year;
                let list = JSON.stringify(ExpertResource);
                ExpertResource.Paper = JSON.parse(list);
                ExpertResource.Paper.Author = temp.creator;
                ExpertResource.Paper.Url = temp.URL;
                break;
              case "I":
                ExpertResource.Title = temp.article;
                ExpertResource.Creator = temp.creator;
                ExpertResource.Journal = temp.kTitle;
                ExpertResource.Year = temp.year;
                let list2 = JSON.stringify(ExpertResource);
                ExpertResource.SCI = JSON.parse(list2);
                break;
              case "E":
                ExpertResource.Title = temp.article;
                ExpertResource.Creator = temp.creator;
                ExpertResource.Journal = temp.kTitle;
                ExpertResource.Year = temp.year;
                ExpertResource.Institute = temp.Institute;
                let list3 = JSON.stringify(ExpertResource);
                ExpertResource.EI = JSON.parse(list3);
                break;
              case "P":
                ExpertResource.Title = temp.patentName;
                ExpertResource.CreatorAll = temp.inventor;
                ExpertResource.No = temp.patentNo;
                ExpertResource.OriginalNo = temp.itemNo;
                ExpertResource.Organization = temp.organisation;
                let list4 = JSON.stringify(ExpertResource);
                ExpertResource.Patent = JSON.parse(list4);
                break;
              case "O":
                ExpertResource.Title = temp.projectName;
                ExpertResource.Year = temp.year;
                ExpertResource.Project = {
                  No: "",
                  Charactor: true,
                  ProjectSource: "",
                  ProjectCategory: "",
                  ProjectLevel: "",
                  ProjectFund: "",
                  ProjectReward: "",
                  ResultForm: "",
                  Presider: "",
                  AcademicDiplomas: "",
                  ProfessionalTitle: "",
                  Mobile: "",
                  Email: "",
                  SubjectType: "",
                  SubjectCategory: "",
                  ResearchCategory: "",
                  SocialEconomic: "",
                  NationalEconomic: "",
                  BeginDate: "",
                  EndDate: "",
                  ContractDate: "",
                  Organization: "",
                  OrganizationRank: 0,
                  Funds: 0,
                  Client: "",
                  Nation: "",
                  Province: "",
                  City: "",
                  Area: "",
                  IsCooperated: true,
                  CoperationForm: "",
                  IsSystem: false,
                  IsValid: true,
                  Id: "",
                  Name: temp.projectName
                };
                break;
              case "B":
                ExpertResource.Title = temp.bookName;
                ExpertResource.Creator = temp.bookAuthor;
                ExpertResource.ISBN = temp.ISBN;
                ExpertResource.Url = temp.URL;
                let list6 = JSON.stringify(ExpertResource);
                ExpertResource.Book = JSON.parse(list6);
                ExpertResource.Book.BookTitle = temp.bookName;
                ExpertResource.Book.Author = temp.bookAuthor;
                break;
              case "A":
                ExpertResource.Title = temp.resultsName;
                ExpertResource.Year = temp.resultYaer;
                ExpertResource.Creator = temp.reward;
                let list7 = JSON.stringify(ExpertResource);
                ExpertResource.Reward = JSON.parse(list7);
                break;
              case "C":
                ExpertResource.Title = temp.article;
                ExpertResource.Author = temp.creator;
                ExpertResource.Journal = temp.kTitle;
                ExpertResource.Year = temp.year;
                ExpertResource.Url = temp.URL;
                let list8 = JSON.stringify(ExpertResource);
                ExpertResource.Conference = JSON.parse(list8);
                ExpertResource.Conference.Url = temp.URL;
                break;
              case "D":
                ExpertResource.Title = temp.paperName;
                ExpertResource.Author = temp.creator;
                ExpertResource.Creator = temp.creator;
                ExpertResource.Tutor = temp.mentor;
                ExpertResource.Institute = temp.Institute;
                ExpertResource.Year = temp.resultYaer;
                ExpertResource.Journal = temp.kTitle;
                let list9 = JSON.stringify(ExpertResource);
                ExpertResource.DegreeObj = JSON.parse(list9);
                break;
              case "T":
                ExpertResource.Name = temp.memberName;
                ExpertResource.Organization = temp.memberOrg;
                ExpertResource.Weight = temp.tightness;
                let list10 = JSON.stringify(ExpertResource);
                ExpertResource.TeamMember = JSON.parse(list10);
                break;
              default:
                break;
            }
            data = {
              ExpertResource: ExpertResource,
              OperateEmployeeId: 0,
              OperateUserId: this.userId + ""
            };
          }
          if (this.editState) {
            this.$emit("edit", data);
          } else {
            this.$emit("add", data);
          }
          this.editState = false;
          this.dialogFormVisible = false;
        } else {
          return false;
        }
      });
    },
    // 重置
    resetForm() {
      this.$refs["form"].resetFields();
    },
    // 编辑
    edit(index) {
      this.dialogFormVisible = true;
      this.form.Id = this.tabelList[index].Id;
      this.form.startTime = this.tabelList[index].BeginDate;
      this.form.endTime = this.tabelList[index].EndDate;
      this.form.institutions = this.tabelList[index].Organization.Name;
      this.form.secInstitutions = this.tabelList[index].Department;
      this.form.title = this.tabelList[index].PositionalTitle;
      this.form.position = this.tabelList[index].Position;
      this.editState = true;
    },
    // 删除
    del(index) {
      let data;
      if (this.code === "1") {
        data = this.tabelList[index];
      } else {
        let temp = this.tabelList[index];
        let list = JSON.stringify(temp);
        let ExpertResource = temp;
        switch (this.code) {
          case "J":
            ExpertResource.Paper = JSON.parse(list);
            break;
          case "I":
            ExpertResource.SCI = JSON.parse(list);
            break;
          case "E":
            ExpertResource.EI = JSON.parse(list);
            break;
          case "P":
            ExpertResource.Patent = JSON.parse(list);
            break;
          case "O":
            ExpertResource.Project = JSON.parse(list);
            break;
          case "B":
            ExpertResource.Book = JSON.parse(list);
            break;
          case "A":
            ExpertResource.Reward = JSON.parse(list);
            break;
          case "C":
            ExpertResource.Conference = JSON.parse(list);
            break;
          case "D":
            ExpertResource.DegreeObj = JSON.parse(list);
            break;
          case "T":
            ExpertResource.TeamMember = JSON.parse(list);
            break;
          default:
            break;
        }
        data = {
          ExpertResource: ExpertResource,
          OperateEmployeeId: 0,
          OperateUserId: this.userId + ""
        };
      }
      this.$emit("del", data);
    },
    // 上传
    upload() {
      this.$refs.upload.submit();
    },
    // 上传文件
    uploadFile(file) {
      let formData = new FormData();
      const _file = file.file;
      formData.append("type", _file.type);
      formData.append("id", _file.uid);
      formData.append("name", _file.name);
      formData.append("lastModifiedDate", _file.lastModifiedDate);
      formData.append("size", _file.size);
      formData.append("file", _file);
      this.$emit("uploadFile", formData);
    },
    getPage(page) {
      this.$emit("page", page.page);
    },
    // 获取新成果
    getNew() {
      if (!this.isNew) {
        return;
      }
      this.intervalId = setInterval(() => {
        this.plain = !this.plain;
      }, 1000);
    },
    // 新成果点击事件
    claim(list) {
      let data = {
        ExpertKId: this.KID,
        ExpertResource: list,
        OperateEmployeeId: 0,
        OperateUserId: this.userId + ""
      };
      this.$emit("add", data);
    }
  },
  mounted() {
    this.getNew();
  }
};
</script>

<style lang="scss">
@-webkit-keyframes twinkling {
  /*透明度由0到1*/
  0% {
    opacity: 0; /*透明度为0*/
  }
  100% {
    opacity: 1; /*透明度为1*/
  }
}
.resultsAll {
  .resultsAll_header {
    margin: 20px;
    display: flex;
    flex-direction: row;
    .newResults {
      margin-right: 10%;
      margin-left: 20px;
      .el-button {
        -webkit-animation: twinkling 2s infinite ease-in-out;
      }
    }
    .el-select {
      width: 65%;
    }
    .el-button {
      margin-left: 10%;
    }
    .cell {
      display: flex;
      .el-button {
        margin-right: 20px;
      }
    }
  }
  .resultsAll_body {
    margin-left: 5%;
  }
}
.claimDialog {
  .el-dialog {
    min-width: 800px;
  }
  .el-dialog__body {
    .claimForm {
      margin: 0 20%;
    }
    .el-date-editor {
      width: 100%;
    }
    .el-form-item__label {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/claim/results.vue